import AgyleDialog from "../../../../components/modal/agyleDialog";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import AgyleTextField from "../../../../components/ui/fields/agyleTextField";
import { Grid } from "@mui/material";
import AgyleButton from "../../../../components/ui/buttons/agyleButton";
import makeStyles from "@mui/styles/makeStyles";
import {useDispatch} from 'react-redux';
import {setSnackbar} from '../../../../store/reducers/globals';

const useClasses = makeStyles((theme) => ({
  textBackground: {
    backgroundColor: theme.palette.background.paperDarker,
  },
  description: {
    color: theme.palette.mode === "light" ? "#000" : "#ACAFB3",
      fontSize: '.8rem'
  },
    resetButton: {
      borderColor: theme.palette.default.main,
      color: theme.palette.default.main
    }
}));

export default function LockSlotConfirmation({ open, onAccept, onClose }) {
  const dispatch = useDispatch();
  const classes = useClasses();

  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    if (!reason) {
      return dispatch(setSnackbar({ type: 'warning', message: 'You have to provide lock reason.' }));
    } else {
      return onAccept(reason)
    }
  }

  return (
    <AgyleDialog
      open={open}
      width="md"
      fullWidth
      onClose={onClose}
      title={"Lock slot"}
      closeButtonOnHeader
      darkContentBackground
      disableActionsCloseButton
      disableEscapeKeyDown
      disableSubmit={!reason}
      onSave={handleSubmit}
      buttons={[
        <AgyleButton
          onClick={() => setReason("")}
          variant="outlined"
          disableTouchRipple
          disableRipple
          className={classes.resetButton}
        >
          Reset
        </AgyleButton>,
      ]}
    >
      <Grid container item xs={12} gap={2}>
        <Grid item xs={12}>
          <Typography variant="body1" fontWeight={600} component="div">
            Are you sure you want to lock slot?
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle2" className={classes.description}>
            Reason
          </Typography>

          <AgyleTextField
            fullWidth
            value={reason}
            noBorder={false}
            placeholder="Please provide a reason for slot lock"
            textFieldClass={classes.textBackground}
            onChange={(e) => setReason(e.target.value)}
            multiline
          />
        </Grid>
      </Grid>
    </AgyleDialog>
  );
}
